module.exports = __webpack_public_path__ + "static/media/frame_02.b33cf796.png";